import { RendererResolver } from "./types.js"

export const isNode = globalThis.process?.release?.name == "node"

//
export const rendererResolvers: RendererResolver[] = []

//
import("./renderers/_import.js")
